{
  "title": "instruments",
  "type": "array",
  "uniqueItems": true,
  "items" : {
    "title": "instrument",
    "type": "object",
    "properties": {
      "id": {
        "description": "The unique identifier for an instrument",
        "type": "integer",
        "minimum": 0
      },
      "name": {
        "description": "The name of an instrument",
        "type": "string",
        "pattern": "\\S+"
      },
      "sound": {
        "description": "The sound ID played by this instrument",
        "type": "string",
        "pattern": "\\S+"
      }
    },
    "required": [
      "id",
      "name"
    ],
    "additionalProperties": false
  }
}